/* eslint-disable jsx-a11y/alt-text */

import React, {useEffect, useCallback} from "react";
import {useAtom, useAtomValue, useSetAtom} from "jotai";
import {vadAtom, audioAtom, genSpeech, processIntent, processLex, stopSpeech} from "../state/audio";
import {createTimer} from "../state/timer";
import {sessionIdAtom} from "../state/active";
import styles from "./Audio.module.css";
import gStyles from "../App.module.css";
Object.assign(styles, gStyles);

import {SERVER, getCache, logState} from "../utils";
import {useMicVAD} from "@ricky0123/vad-react";

// fetch audio results from server
const fetchAudioResults = (samples: Int16Array) => {
  //const audio = new Blob(samples);
  const audio = samples;
  console.log("got audio", audio, samples.length, samples[0]);
  fetch(`${SERVER}/audio/`, {method: "POST", body: audio})
    .then((resp) => resp.json())
    .then((obj) => processLex(obj));
};

const CACHE_VARS = ["volume", "rate"];

export function Audio() {
  const [audio, setAudio] = useAtom(audioAtom);
  const {vadState, volume, rate} = audio;
  const sessionId = useAtomValue(sessionIdAtom);
  const cache = getCache();
  const updateAudio = useCallback((key: keyof typeof audio, value: any) => {
    setAudio((audio) => {
      audio[key] = value;
      if (CACHE_VARS.includes(key)) {
        cache.setItem(key, value);
      }
    });
  }, [cache, setAudio]);
  useEffect(() => {
    logState({_name: 'audio-audio', sessionId, ...audio});
  }, [audio]);
  const setVad = useSetAtom(vadAtom);
  /*
  const vad = useMicVAD({
    startOnLoad: false,
    onSpeechStart: () => {
      console.log("got speech start");
      updateAudio('vadState', "recording");
    },
    onVADMisfire: () => {
      console.log("got vad misfire");
      updateAudio('vadState', "listening");
    },
    onSpeechEnd: (audio: Float32Array) => {
      const int16 = new Int16Array(audio.length);
      for (let i = 0; i < audio.length; i++) {
        int16[i] = audio[i] * 32767;
      }
      console.log("got speech end", audio, int16);
      updateAudio('vadState', "listening");
      fetchAudioResults(int16);
    }
  });
  */
  const vad = null;
  setVad(vad);
  //console.log('top of Audio', vad, vadState, volume, rate);

  // load volume and rate from cache
  useEffect(() => {
    CACHE_VARS.forEach((key) => {
      cache.getItem(key).then((value) => {
        if (value) {
          if (key === 'rate') {
            value = 1.0;
          }
          updateAudio(key, value);
        }
      });
    });
  }, [cache, updateAudio]);

  const toggleListening = useCallback(() => {
    console.log('in toggleListening', vad, vad.listening);
    // if it's recording or listening, pause it
    if (vad.listening || vad.userSpeaking) {
      vad.pause();
      updateAudio("vadState", "off");
    } else {
      //vad.start(); //FIXME disabled for now
      //updateAudio("vadState", "listening");
    }
  }, [vad, updateAudio]);
  const colorsByState = {
    off: '',
    listening: "green",
    recording: "red",
  };
  const iconStyle = {
    position: "relative",
    width: 15,
    height: 15,
    top: 4,
  };
  return (
    <div className={`${styles.audio} ${styles.navbar}`}>
      <img
        src="/icons/microphone.png"
        style={{backgroundColor: colorsByState[vadState], ...iconStyle}}
        onClick={() => toggleListening()}
      />
      <span>
        <img
          src="/icons/volume.png"
          onClick={() => processIntent({name: "repeat"})}
          style={Object.assign({}, iconStyle, {top: -6})}
        />
        <input
          type="range"
          min={0}
          max={1.0}
          step={0.1}
          value={volume}
          onChange={(e) => updateAudio("volume", e.target.value)}
          style={{width: 70}}
        />
      </span>
      <span>
        <img
          src="/icons/speed.png"
          style={Object.assign({}, iconStyle, {top: -6})}
          onClick={() => genSpeech('testing out the generate speech functionality')}
        />
        <input
          type="range"
          min={0.1}
          max={2.5}
          step={0.1}
          value={rate}
          disabled={true}
          onChange={(e) => updateAudio("rate", e.target.value)}
          style={{width: 70}}
        />
      </span>
      <img
        /* src={isRecording ? "/icons/circle-red.png" : "/icons/circle-open.png"} */
        src="/icons/circle-open.png"
        style={iconStyle}
        onClick={() => stopSpeech()}
      />
    </div>
  );
}
